/**************************************************************************************************/
/*   File: /src/app/shared/components/number/number.component.ts                                  */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Monday February 25th 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Tue Feb 26 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Component, Input, OnInit } from '@angular/core';
import { InternalFormsSharedModule } from '@angular/forms/src/directives';
import { Store } from '@ngrx/store';

import * as fromActions from '../../../stores/actions';
import * as fromStates from '../../../stores/states';
import * as fromEnums from '../../enums';
import * as fromModels from '../../models';

/**
 * The number component
 */
@Component({
  selector: 'nwpl-frnt-number-component',
  templateUrl: './number.component.html',
  styleUrls: ['./number.component.scss']
})
export class NumberComponent {

  /**
   * The ordinal number to show
   */
  @Input() ordinal: number;

  /**
   * If disabled equal to true
   */
  @Input() disabled = false;

  /**
   * If selected equal to true
   */
  @Input() selected = false;
  /**
   * The constructor
   */
  constructor() { }

}
